import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsswitch',
	templateUrl:'./BSSwitchPluginCompPage.html',
	styles: [],
	styleUrls:['./BSSwitchPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSSwitchPluginCompPage
{
	mdContent_865 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.buttons.switches.BSSwitch;
\`\`\``;
	mdContent_866 = `\`\`\`java
BSSwitch()
\`\`\``;
	mdContent_867 = `\`\`\`java
BSSwitch&lt;?&gt; sw = new BSSwitch&lt;&gt;();
sw.setLabel("Enable notifications");
sw.setChecked(true);
\`\`\``;
}
